import React from "react";
import { Card } from "primereact/card";
import "../officers-form.scss";
import PermissionGate from "~/components/PermissionGate";
import { Button } from "primereact/button";
import OfficerRegistration from "../OfficersRegistration";
import Notification from "../../entities/notification/Notification";
import useOfficerPersonalInfo from "./useOfficerPersonalInfo";
import { useOfficerDetails } from "./OfficerDetails";

import AuditSidebar from "../../audit-sidebar/AuditSidebar";
import API_ROUTES from "../../../api-routes";

const OfficerPersonalInfo = () => {
  const { type, regData } = useOfficerDetails();
  const entityId = regData?.entityData?.id;
  const {
    regData: officerData,
    isEditing,
    localSetRegData,
    formResetRef,
    successMessage,
    setSuccessMessage,
    isSaveDisabled,
    setIsSaveDisabled,
    isLoading,
    handleEditClick,
    handleDiscardClick,
    handleSaveClick,
    btnToggle,
    setBtnToggle,
    formDetails,
    setFormDetails,
    isAuditSidebarVisible,
    setAuditSidebarVisible,
  } = useOfficerPersonalInfo(type);

  const auditLabels = () => ({
    update: "Information Updated",
    create: `${type === "officer" ? "Officer Added" : "Attorney Added"}`,
    delete: `${type === "officer" ? "Officer Deleted" : "Attorney Deleted"}`,
  });
  return (
    <Card className="personal-info-card">
      <div className="personal-info-container flex justify-content-between formgrid grid grid-nogutter">
        <div>
          <p className="personal-information-heading">Personal Information</p>
          <p className="input-label m-0 personal-info-sub-heading">
            {type === "officer"
              ? "Personal information and contact details for this officer."
              : "Personal information and contact details for this Attorney."}
          </p>
        </div>
        <PermissionGate
          resource="officer"
          action="modify"
          resourceAttr={{ entity_id: entityId }}
        >
          <div className="flex gap-3">
            {isEditing ? (
              <div className="flex gap-2">
                <Button className="edit-button" onClick={handleDiscardClick}>
                  Discard
                </Button>
                <Button
                  type="submit"
                  className={`save-changes-btn ${isSaveDisabled && "disable"}`}
                  disabled={isSaveDisabled}
                  onClick={handleSaveClick}
                  loading={isLoading}
                >
                  {"Save Changes"}
                </Button>
              </div>
            ) : (
              <>
                <PermissionGate
                  resource="audittrail"
                  action="view"
                  resourceAttr={{ entity_id: entityId }}
                >
                  <Button
                    className="edit-button"
                    onClick={() => setAuditSidebarVisible(true)}
                  >
                    View History
                    <span className="pi pi-history mb-1 ml-2" />
                  </Button>
                </PermissionGate>
                <Button
                  className="edit-info-button"
                  onClick={() => {
                    handleEditClick();
                    setIsSaveDisabled(true);
                  }}
                >
                  Edit
                  <span className="pi pi-pencil text-xs ml-2"></span>
                </Button>
              </>
            )}
          </div>
        </PermissionGate>
        <Notification
          successMessage={successMessage}
          setSuccessMessage={setSuccessMessage}
        />
      </div>
      <OfficerRegistration
        btnToggle={btnToggle}
        setBtnToggle={setBtnToggle}
        formDetails={formDetails}
        setFormDetails={setFormDetails}
        type={type}
        regData={officerData}
        setRegData={localSetRegData}
        isEditing={isEditing}
        isNewOfficer={false}
        setFormResetRef={(resetFn) => (formResetRef.current = resetFn)}
      />

      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Personal Information"
          endpoint={API_ROUTES.FETCH_OFFICER_AUDIT}
          id={officerData?.id}
          labels={auditLabels}
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
        />
      )}
    </Card>
  );
};

export default OfficerPersonalInfo;
